import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

export const TipoTransportadorAjuda: React.FC = () => {
  const popover = (
    <Popover
      id="popover-tipo-transportador-ajuda"
      className="shadow-sm border"
      style={{ maxWidth: 380, zIndex: 1060 }}
    >
      <Popover.Header
        as="h6"
        className="fw-bold py-2 px-3 m-0 bg-light text-dark border-bottom"
      >
        O caminhão está no nome/documento da minha empresa?
      </Popover.Header>
      <Popover.Body className="p-3 small text-secondary">
        <div className="mb-2">
          <strong className="text-success">SIM</strong>{" "}
          <span className="text-muted">→</span> Deixe o campo <strong>VAZIO</strong>.
        </div>
        <div className="mb-2">
          <strong className="text-primary">NÃO</strong>, é de um{" "}
          <strong>motorista autônomo (CPF)</strong>{" "}
          <span className="text-muted">→</span> Preencha o proprietário e selecione{" "}
          <strong>2 - TAC</strong>.
        </div>
        <div>
          <strong className="text-primary">NÃO</strong>, é de{" "}
          <strong>outra empresa de transporte (CNPJ)</strong>{" "}
          <span className="text-muted">→</span> Preencha o proprietário e selecione{" "}
          <strong>1 - ETC</strong>.
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      placement="auto"
      rootClose
      overlay={popover}
    >
      <span
        role="button"
        tabIndex={0}
        aria-label="Ajuda sobre Tipo de Transportador"
        className="text-muted ms-1 d-inline-flex align-items-center justify-content-center"
        style={{
          cursor: "pointer",
          pointerEvents: "auto",
          fontSize: "0.85rem",
          lineHeight: 1,
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <FontAwesomeIcon icon={faQuestionCircle} />
      </span>
    </OverlayTrigger>
  );
};

export default TipoTransportadorAjuda;
